import React from "react";
import {
  Box,
  Chip,
  IconButton,
  TextField,
  Typography,
  styled as MStyled,
} from "@mui/material";
import { AddCircle, RemoveCircle } from "@mui/icons-material";

const CartDescriptionLine = MStyled(Typography)({
  color: "#666",
  fontWeight: "300",
  fontSize: "13px",
  textAlign: "justify",
  width: "100%",
  boxSizing: "border-box",
  marginBottom: "8px",
});

export const CartItemEditForm = ({
  id,
  itemName,
  note,
  quantity,
  description,
  price,
  variation,
  onDecreaseItemQuantity,
  onIncreaseItemQuantity,
  currency,
  onUpdateNoteInCart,
}: CartItemEditFormProps) => {
  return (
    <Box paddingRight={"4px"} boxSizing={"border-box"} width={"100%"}>
      <Box
        display={"flex"}
        justifyContent={"space-between"}
        alignItems={"center"}
      >
        <Typography>{itemName}</Typography>

        <Box display={"flex"} alignItems="center">
          <IconButton
            data-testid="test-id-decrease-item-quantity"
            aria-label="decrease-item-quantity"
            role="button"
            onClick={() => onDecreaseItemQuantity(id)}
          >
            <RemoveCircle />
          </IconButton>

          <Chip
            role="quantity-box"
            aria-label="quantity-box"
            variant="filled"
            label={quantity}
            size={"medium"}
          />

          <IconButton
            data-testid="test-id-increase-item-quantity"
            aria-label="increase-item-quantity"
            role="button"
            onClick={() => onIncreaseItemQuantity(id)}
          >
            <AddCircle />
          </IconButton>

          <Typography width={"60px"} align="right">
            {currency}
            {parseFloat(price.toString()).toFixed(2)}
          </Typography>
        </Box>
      </Box>

      {!!variation && (
        <Box display="flex">
          <Typography fontWeight={"bold"} sx={{ marginRight: "4px" }}>
            Variation:
          </Typography>
          <Typography>{variation}</Typography>
        </Box>
      )}
      <TextField
        variant="outlined"
        size="small"
        fullWidth
        placeholder="Add note"
        value={note}
        onChange={(event) => onUpdateNoteInCart(id, event.target.value)}
        sx={{ mt: 0.75, mb: 0.25 }}
      />

      <CartDescriptionLine>{description}</CartDescriptionLine>
    </Box>
  );
};

type CartItemEditFormProps = {
  id: number;
  itemName: string;
  note: string;
  quantity: number;
  description?: string;
  price: number;
  currency: string;
  variation?: string;
  onDecreaseItemQuantity: (id: number) => void;
  onIncreaseItemQuantity: (id: number) => void;
  onUpdateNoteInCart: (id: number, note: string) => void;
};
